// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".revico-widget .revico-community-talk .revico-community-talk-require-login {\n  margin: 12px 0 12px 0;\n  font-size: 0.8em;\n  text-align: center;\n  white-space: pre-wrap;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
